// extracted by mini-css-extract-plugin
export default {"button":"Button_button__h-PxG","loader":"Button_loader__CaIRy","icon":"Button_icon__7fser"};